import { Box, Chip, Link, Typography } from '@mui/material'
import { DashboardData } from 'store/dashboard/types'
import SectionCard from './SectionCard'
import { SearchStatus } from 'store/commonTypes'

type Props = {
  dashboardData: DashboardData | null
}

function RecentCompanySearchesCard({ dashboardData }: Props) {
  const getStatusChip = (status: SearchStatus | string) => {
    let chipProps: { label: string; bgcolor: string; color: string }

    switch (status) {
      case 'complete':
        chipProps = {
          label: 'Completed',
          bgcolor: 'transparent',
          color: 'primary.main',
        }
        break
      case 'search_finished':
        chipProps = {
          label: 'Click to generate report',
          bgcolor: 'transparent',
          color: 'primary.main',
        }
        break
      case 'report_compiling':
        chipProps = {
          label: 'Report Compiling',
          bgcolor: 'rgba(255, 193, 7, 0.2)',
          color: '#b26a00',
        }
        break
      case 'search_processing':
        chipProps = {
          label: 'Processing',
          bgcolor: 'rgba(255, 193, 7, 0.2)',
          color: '#b26a00',
        }
        break
      case 'queued':
        chipProps = {
          label: 'Queue',
          bgcolor: 'rgba(255, 152, 0, 0.2)',
          color: '#bf360c',
        }
        break
      default:
        chipProps = {
          label: status,
          bgcolor: 'grey.200',
          color: 'black',
        }
    }

    return (
      <Chip
        label={chipProps.label}
        sx={{
          fontWeight: 500,
          height: 24,
          fontSize: 13,
          bgcolor: chipProps.bgcolor,
          color: chipProps.color,
        }}
        size="small"
      />
    )
  }
  return (
    <SectionCard title="Recent single patent reports">
      {dashboardData?.singlePatentSearches.recentSearches.slice(0, 5).map((search, index) => {
        const content = (
          <>
            <Typography
              variant="body2"
              noWrap
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                width: '100%',
                color: 'black',
              }}>
              {search.name}
            </Typography>
            {getStatusChip(search.status)}
          </>
        )

        const wrapperStyles = {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          py: 0.5,
          px: 1,
          borderRadius: 1,
        }
        return (
          search.status !== '111' && (
            <Link
              key={search.id}
              href={`/dashboard/reporting/single-search/${search.id}`}
              underline="none"
              sx={{
                ...wrapperStyles,
                '&:hover': {
                  bgcolor: '#f5f5f5',
                },
              }}>
              {content}
            </Link>
          )
        )
      })}
    </SectionCard>
  )
}

export default RecentCompanySearchesCard
